import { render, staticRenderFns } from "./ShopBalanceTx.vue?vue&type=template&id=7140b3fa&scoped=true&"
import script from "./ShopBalanceTx.vue?vue&type=script&lang=js&"
export * from "./ShopBalanceTx.vue?vue&type=script&lang=js&"
import style0 from "./ShopBalanceTx.vue?vue&type=style&index=0&id=7140b3fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7140b3fa",
  null
  
)

export default component.exports